import { axiosInstanceAuth } from "./setup";
import { EntityFields, EntityType, IAddAccountRequest, UserResponse } from "./interface";

export const handleGetAccountsApi = async (): Promise<UserResponse[]> => {
  const result = await axiosInstanceAuth().get(`/admin/fetch_users`);
  return result.data.data as UserResponse[];
};

export const sendOTPForgetPasswordApi = async (email: string) => {
  return axiosInstanceAuth().post(`/admin/send_otp_account`, {
    email,
    templateId: "d-e5fda7b8f91641539e1e5c40c34dfe50",
    websiteRedirect: window.location.origin,
  });
};

export const verifyAndUpdatePasswordAPI = async (data: {
  email: string;
  otp: string;
  password: string;
}) => {
  return axiosInstanceAuth().post(`/admin/verify_and_update_password`, data);
};

export const handleGetCompanies = async () => {
  return axiosInstanceAuth().get(`/admin/fetch_companies`);
};

export const handleGetCountries = async () => {
  return axiosInstanceAuth().get(`/admin/fetch_countries`);
};

export const handleCreateAccountApi = async (formData: IAddAccountRequest) => {
  const result = await axiosInstanceAuth().post(`/admin/create_account`, formData);
  return result.data;
};

export const handleUpdateAccountApi = async (formData: IAddAccountRequest) => {
  const result = await axiosInstanceAuth().put(`/admin/update_account`, formData);
  return result.data;
};

export const handleDeleteAccountApi = async (id: number) => {
  return axiosInstanceAuth().post(`/admin/delete_account`, { id });
};

export const handleDeleteDepartment = async (id: number) => {
  return axiosInstanceAuth().delete("/admin/delete_department", { data: { id } });
};

export const handleDeleteCountry = async (id: number) => {
  return axiosInstanceAuth().delete(`/admin/delete_country`, { data: { id } });
};

export const handleDeleteRole = async (id: number) => {
  return axiosInstanceAuth().delete(`/admin/delete_role`, { data: { id } });
};

export const handleCreateNewCompany = async (name: string) => {
  return axiosInstanceAuth().post(`/admin/create_company`, { name });
};

export const handleGetCompanyUserCount = async (companyId: number) => {
  const result = await axiosInstanceAuth().get(`/admin/company_user_count/${companyId}`);
  return result.data;
};

export const handleDeleteCompany = async (id: number) => {
  return axiosInstanceAuth().delete(`/admin/delete_company`, { data: { id } });
};

export const handleUpdateCompany = async (id: number | string, name: string) => {
  return axiosInstanceAuth().post(`/admin/update_company?id=${id}`, { name });
};

export const handleCreateNewEntity = async (type: EntityType, fields: EntityFields) => {
  return axiosInstanceAuth().post(`/admin/create_${type}`, { ...fields });
};

export const handleUpdateEntity = async (type: EntityType, fields: EntityFields) => {
  return axiosInstanceAuth().put(`/admin/update_${type}`, { ...fields });
};

export const handleGetDepartmentsByCompanyId = async (companyId: number | string) => {
  return axiosInstanceAuth().get(`/admin/fetch_departments?company_id=${companyId}`);
};
